'use strict';

module.exports = require('./es2015');



//////////////////
// WEBPACK FOOTER
// ./~/es-to-primitive/es6.js
// module id = 909
// module chunks = 0